import { Route, Routes } from "react-router-dom";
import Index, { ApprovalRequests, Create, Dashboard } from "./pages";
import { SkuCreationApprovalProvider } from "../../context/SkuCreationApprovalContext";
import { MpnCreateProvider } from "./context/create/CreateMpnContext";

const MpnRoutes = () => (
  <SkuCreationApprovalProvider>
    <Routes>
      <Route path="/" element={<Index />}>
        <Route
          path="create"
          element={
            <MpnCreateProvider>
              <Create />
            </MpnCreateProvider>
          }
        />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="requests" element={<ApprovalRequests />} />
      </Route>
    </Routes>
  </SkuCreationApprovalProvider>
);
export default MpnRoutes;
